import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import $ from "jquery";

import template from './dropDown2.rt';
import onClickOutside from 'react-onclickoutside';

class DropDown2 extends PureComponent {
  constructor(props) {
    super(props);
    this.setAddNewInputRef = this.setAddNewInputRef.bind(this);
    this.setStateFromProps = this.setStateFromProps.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.showAddNewInput = this.showAddNewInput.bind(this);
    this.setStateFromProps(props, true);
  }

  setStateFromProps = (props, onInit = false) => {
    let itemList = props.items;
    if(props.items && props.items.length > 0) {
      if(props.items[0].items) {
        itemList = _.flatMap(props.items, i => i.items);
      }
    }
    let selected = _.find(itemList, i => i.value == props.selected);
    if(!selected && itemList.length > 0) {
      console.log("Could not find selected value of", props.selected, "in", itemList);
      selected = itemList[0];
    }
    let items = props.items;
    if(this.props.sort !== false)
      items = _.sortBy(props.items, i => _.trim(i.text.toLowerCase()));

    let newState = {
      selected: selected,
      items,
      searchText: '',
      addNewText: '',
      addNewVisible: false,
      filteredItems: onInit ? items : this.state.filteredItems
    }
    newState.items.forEach(i => {
      if(i.items && i.items.length) {
        i.items = _.sortBy(i.items, i => _.trim(i.text.toLowerCase()));
      }
    })
    if(onInit) {
      this.state = newState;
    } else {
      this.setState(newState);
    }
  }

  handleSelectItem = (item) => {
    this.setState({selected: item});
    this.props.onSelect(item.value ? item.value : item, item);
  }

  handleChangeSearchText = (e) => this.setState({
    searchText: e.target.value,
    filteredItems: this.getFilteredItems(e.target.value)
  })

  getFilteredItems = (searchText) => {
    let items = JSON.parse(JSON.stringify(this.state.items));
    if(items && items.length > 0 && items[0].items && searchText) {
      items.forEach(i => {
        i.items = [...i.items.filter(item => i.text.toLowerCase().includes(_.trim(searchText.toLowerCase())) || item.text.toLowerCase().includes(_.trim(searchText.toLowerCase())))];
      })
    } else {
      items = items.filter(i => i.text.toLowerCase().includes(_.trim(searchText.toLowerCase())));
    }
    return items;
  }

  handleClickOutside = (evt) => {
    if(this.props.onClickOutside) {
      this.props.onClickOutside(evt);
    }
  }

  showAddNewInput = () => {
    this.setState({addNewVisible: true}, () => {
      window.setTimeout(() => {
        $(this.addNewInputNode).focus();
      }, 100);
    });
  }

  setAddNewInputRef = (node) => {
    this.addNewInputNode = node;
  }

  componentWillReceiveProps = (newProps) => {
    if(!_.isEqual(this.props.items, newProps.items))
      this.setStateFromProps(newProps);
  }

  rowRenderer = ({
                index, // Index of row
                isScrolling, // The List is currently being scrolled
                isVisible, // This row is visible within the List (eg it is not an overscanned row)
                key, // Unique key within array of rendered rows
                parent, // Reference to the parent List (instance)
                style // Style object to be applied to row (to position it);
                // This must be passed through to the rendered row element.
              }) => {
    const item = this.state.filteredItems[index];
    return <li key={key} style={style} className={"select2-dropdown__list-option"
    + (item.value == this.state.selected || item.value == this.state.selected.value ?
      " select2-dropdown__list-option--active" : "")}
               onClick={() => this.handleSelectItem(item)}>{item.text}</li>
  };



  render = template
}

DropDown2.propTypes = {
  items: PropTypes.array.isRequired,
  wide: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  useVirtualizedList: PropTypes.bool
};

export default onClickOutside(DropDown2);
